
    import {
        defineComponent,
    } from 'vue';
    import useRailwayToursListPopupAdapter from '../common/useRailwayToursListPopupAdapter';
    import RailwayToursListPopup from './RailwayToursListPopup.vue';

    export default defineComponent({
        name: 'RailwayToursListPopupAdapter',
        components: {
            RailwayToursListPopup,
        },
        setup() {
            const {
                railwayTourItems,
                railwayToursListPopup,
                open,
                close,
            } = useRailwayToursListPopupAdapter();

            return {
                railwayTourItems,
                railwayToursListPopup,
                open,
                close,
            };
        },
    });
